<div *ngIf="visible" class="content-loader">
  <div class="loader"></div>
</div>
